"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAdjustmentRecord = exports.IPendingChargeDetail = exports.IPendingCharge = void 0;
const openapi_1 = require("../../../openapi");
const IAdjustmentRecord_1 = __importDefault(require("./IAdjustmentRecord"));
exports.IAdjustmentRecord = IAdjustmentRecord_1.default;
const IPendingChargeDetail_1 = __importDefault(require("./IPendingChargeDetail"));
exports.IPendingChargeDetail = IPendingChargeDetail_1.default;
class IPendingCharge {
    id;
    orgKey;
    customerId;
    customerName;
    warehouseId;
    warehouseName;
    class;
    transactionId;
    glAccount;
    transactionType;
    category;
    chargeType;
    chargeLabel;
    memo;
    countingUnit;
    qty;
    chargePerUnit;
    total;
    status;
    created; // datetime as number
    confirmDate; // datetime as number
    chargeDetail;
    chargeAdjustments;
    chargeEdits;
    predefinedChargeId;
    predefinedManualRateId;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IPendingCharge.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IPendingCharge.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "customerId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "customerName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "warehouseId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "warehouseName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "class", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "transactionId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "glAccount", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "transactionType", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "category", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "chargeType", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "chargeLabel", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "memo", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "countingUnit", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "qty", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "chargePerUnit", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "total", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IPendingCharge.prototype, "status", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "created", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IPendingCharge.prototype, "confirmDate", void 0);
__decorate([
    (0, openapi_1.Schema)(() => IPendingChargeDetail_1.default)
], IPendingCharge.prototype, "chargeDetail", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IAdjustmentRecord_1.default) })
], IPendingCharge.prototype, "chargeAdjustments", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IAdjustmentRecord_1.default) })
], IPendingCharge.prototype, "chargeEdits", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IPendingCharge.prototype, "predefinedChargeId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IPendingCharge.prototype, "predefinedManualRateId", void 0);
exports.IPendingCharge = IPendingCharge;
